import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Flex, Input, Row, Select, theme } from 'antd';
import React, { Ref, useEffect, useState } from 'react';
import { useSetOrigin } from 'services/journeys';
import { useDebounce } from 'util/Hooks';
import { useJourneyDashboardContext } from '../context';
import { GeolocationType } from 'interfaces/journey';

interface EndpointsSelectorProps {
  disabled?: boolean;
}

const options = [
  { value: GeolocationType.DistributionCenter, label: 'PaQuery Point' },
  { value: GeolocationType.CustomAddress, label: 'Dirección Personalizada' },
];

const EndpointsSelector = React.forwardRef<
  HTMLDivElement,
  EndpointsSelectorProps
>(({ disabled }, ref) => {
  const { token } = theme.useToken();
  const { id, originAddress } = useJourneyDashboardContext();
  const [start, setStart] = useState<GeolocationType>(
    originAddress?.label ?? GeolocationType.DistributionCenter,
  );
  const [startAddress, setStartAddress] = useState(
    originAddress?.label === GeolocationType.CustomAddress
      ? (originAddress?.address ?? '')
      : '',
  );
  const {
    mutateAsync: setOrigin,
    isPending: isPendingOrigin,
    isError,
  } = useSetOrigin();

  useEffect(() => {
    setStart(originAddress?.label || GeolocationType.DistributionCenter);
    if (originAddress?.label === GeolocationType.CustomAddress) {
      setStartAddress(originAddress?.address || '');
    }
  }, [originAddress?.label, originAddress?.address, isError]);

  const handleChange = (value: GeolocationType) => {
    if (!id) return;
    setStart(value);

    if (value === GeolocationType.DistributionCenter) {
      setOrigin({
        journeyId: id,
        geolocationType: value,
      });
    }
  };

  const handleChangeAddress = () => {
    if (
      id &&
      start === GeolocationType.CustomAddress &&
      startAddress &&
      startAddress !== originAddress?.address
    ) {
      setOrigin({
        journeyId: id,
        geolocationType: start,
        address: startAddress,
      }).catch(() => {
        if (originAddress?.label === GeolocationType.CustomAddress)
          setStartAddress(originAddress?.address || '');
      });
    }
  };

  return (
    <Row style={{ width: '100%' }} ref={ref as Ref<HTMLDivElement>}>
      <Col xs={24}>
        <Card
          bodyStyle={{
            padding: '10px',
          }}
        >
          <Flex vertical>
            <Flex style={{ margin: '-8px 8px 0 8px', color: 'darkgray' }}>
              <p style={{ margin: 0 }}>Inicio</p>
            </Flex>
            <Flex gap="small">
              <Select
                value={start}
                options={options}
                onChange={handleChange}
                disabled={disabled}
                style={{ flex: 1 }}
                suffixIcon={
                  isPendingOrigin ? (
                    <LoadingOutlined style={{ color: token.colorPrimary }} />
                  ) : undefined
                }
              />
              {start === GeolocationType.CustomAddress && (
                <Input
                  placeholder="Ingrese la dirección"
                  style={{ flex: 2 }}
                  value={startAddress}
                  onPressEnter={handleChangeAddress}
                  onBlur={handleChangeAddress}
                  onChange={(v) => setStartAddress(v.target.value)}
                />
              )}
            </Flex>
          </Flex>
        </Card>
      </Col>
    </Row>
  );
});

export default EndpointsSelector;
